// extracted by mini-css-extract-plugin
export default {"header":"map_header__ylF24","tooltip":"map_tooltip__0DSwd","tooltipMobile":"map_tooltipMobile__a0aNR","tooltipLink":"map_tooltipLink__Zcy+j"};